import { ref } from 'vue'

export const DEFAULT_TOAST_TIMEOUT = 3000

const toasts = ref([])
const timers = new Map()

let lastId = 0

const cancelTimer = (id) => {
  if (!timers.has(id)) return
  clearTimeout(timers.get(id))
  timers.delete(id)
}

const removeToast = (id) => {
  cancelTimer(id)
  const index = toasts.value.findIndex((toast) => toast.id === id)
  if (index === -1) return false
  toasts.value.splice(index, 1)
  return true
}

const addToast = ({ message = '', type = 'success', timeout = DEFAULT_TOAST_TIMEOUT } = {}) => {
  lastId += 1
  const id = lastId
  toasts.value.push({ id, message, type })
  if (typeof timeout === 'number' && timeout > 0) {
    timers.set(
      id,
      setTimeout(() => removeToast(id), timeout)
    )
  }
  return id
}

const clearToasts = () => {
  timers.forEach((timer) => clearTimeout(timer))
  timers.clear()
  toasts.value = []
}

export function useToasts() {
  return {
    toasts,
    addToast,
    removeToast,
    clearToasts
  }
}
